import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, EMPLOYER_SUBSCRIPTIONS_PAYMENT, EMPLOYER_SUBSCRIPTIONS_PAYMENT_TOPUP, EMPLOYER_SUBSCRIPTIONS_TOPUP } from "../../../common/URLs";

export const fetchEmployerSubscriptionsTopUp = async () => {
    const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_SUBSCRIPTIONS_TOPUP}`; // Proxy path
    try {
        const token = await fetchToken()

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        // console.log("response", response)
        const data = await response.json();
        return data;
    } catch (error) {
        // console.log("error", error);
        return error
    }
};

export const fetchEmployerSubscriptionsTopUpPaymentCheck = async (uuid) => {
    const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_SUBSCRIPTIONS_PAYMENT_TOPUP}/${uuid}`; // Proxy path
    try {
        const token = await fetchToken()

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        // console.log("response", response)
        const data = await response.json();
        return data;
    } catch (error) {
        // console.log("error", error);
        return error
    }
};